export default __webpack_public_path__ + "static/media/revoplas.3039d87d.svg";